export const TEST_IDS = {
	entity_type: 'entity_type',
	data_type: 'data_type',
	path_input_tooltip: 'path_input_tooltip',
	data_type_input_tooltip: 'data_type_input_tooltip',
	mandatory_attribute_tooltip: 'mandatory_attribute_tooltip',
	show_on_mobile_tooltip: 'show_on_mobile_tooltip'
};
